import { Flex } from "antd";
import CrossArrow from "../images/CrossArrow";

const ScreenWarning = () => {

  const style = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "#262626",
    color: "white",
    textAlign: "center",
    fontSize: "1rem",
    zIndex: 9999,
  };

  return (
    <Flex justify='center' align='center' vertical style={style}>
      <CrossArrow color={'#D86ECC'} scale={0.3} style={{marginBottom:'10vh'}}  />
      To get the full experience, please use a large landscape screen.
    </Flex>
  );
};

export default ScreenWarning;